import { RuntimeType, getScriptParams } from '@nizza/core';
import '@nizza/player';
import { LivestreamingProps, WC_NAME } from '@nizza/player';
import {
  initializeNizzaRuntime,
  registerLitComponent,
  setDefaultProductDataSource,
} from '@nizza/utils';
import env from '~env';
import logger from '~logger';

const runtime = initializeNizzaRuntime({ env, logger });

const getPlayerProps = () => {
  const params = getScriptParams(`${WC_NAME}-script`);
  const conf = env.config;

  logger.debug(
    `Nizza player search query:`,
    Object.fromEntries(params.entries()),
  );

  const get = (type: 'S' | 'B' | 'N', param: string, defaultValue: any) => {
    const value = params.get(param);
    if (value === null) return defaultValue;
    if (type === 'S') return String(value);
    if (type === 'B') return value === 'true';
    if (type === 'N') return Number(value);
  };

  const config: LivestreamingProps = {
    ...conf,
    idLivestreaming: get('S', 'id', conf.idLivestreaming),
    account: get('S', 'account', conf.account),
    originOfProducts: get('S', 'originOfProducts', conf.originOfProducts),
    isInGlobalPage: get('B', 'isInGlobalPage', conf.isInGlobalPage),
    showSidebarProducts: get(
      'B',
      'inactiveSidebarProducts',
      conf.showSidebarProducts,
    ),
    showProductsCarousel: get(
      'B',
      'inactiveProductsCarousel',
      conf.showProductsCarousel,
    ),
    showChat: get('B', 'inactivateChat', conf.showChat),
    showLike: get('B', 'inactivateLike', conf.showLike),
    showViewers: get('B', 'inactivateViewers', conf.showViewers),
    redirectTo: get('B', 'pdp', conf.redirectTo),
    showQuickView:
      get('B', 'showQuickView', conf.showQuickView) ||
      get('B', 'quickView', conf.showQuickView),
    isInfinite: get('B', 'isInfinite', conf.isInfinite),
    time: get('N', 'time', conf.time || 10),
  };

  return { config };
};

registerLitComponent(runtime, WC_NAME, WC_NAME);

async function configure() {
  const props = getPlayerProps();
  await runtime.configureStore({ account: props.config.account });
  setDefaultProductDataSource(runtime);
  return props;
}

runtime.config(RuntimeType.Local, { skipBaseBehavior: true }, async config => {
  const { component } = config;
  const playerProps = await configure();
  await component.render(playerProps);
});

runtime.config(
  RuntimeType.VtexLegacy,
  { skipBaseBehavior: true },
  async config => {
    const { component } = config;
    const playerProps = await configure();
    await component.render(playerProps);
  },
);

runtime.config(
  RuntimeType.External,
  { skipBaseBehavior: true },
  async config => {
    const { component } = config;
    const props = await configure();
    await component.render(props);
  },
);

runtime.execute();
